import { createSlice} from '@reduxjs/toolkit'

const auth = localStorage.getItem("data");

export const counterSlice = createSlice({
  name: 'appStore',
  initialState : {
    auth: auth ? JSON.parse(auth) : null
  },
  reducers: {
    setAuth: (state, action) => {
      state.auth = action.payload;
    }
  }
})

// Action creators are generated for each case reducer function
export const { setAuth } = counterSlice.actions

export default counterSlice.reducer;

